import { Provider } from '@angular/core';

import { BhApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const PhoneBhGrpcContractProvider: Provider = {
  provide: BhApi.PhoneBhGrpcContractClient,
  useFactory: CommonGrpcContractFactory(BhApi.PhoneBhGrpcContractClient),
};
